import { InjectionToken } from "@angular/core";

export const CondicionesToken = new InjectionToken("CondicionesToken");
